import { type WithChildren } from '@dynatrace/strato-components/core';

import { TimeseriesAnnotationsDataProvider } from './TimeseriesAnnotationsDataProvider.js';
import { TimeseriesChartXScaleProvider } from './TimeseriesChartXScaleProvider.js';
import { TimeseriesChartYScalesProvider } from './TimeseriesChartYScalesProvider.js';
import { TimeseriesFormatterProvider } from './TimeseriesFormatterProvider.js';

export const TimeseriesChartProviders = ({ children }: WithChildren) => (
  <TimeseriesChartXScaleProvider>
    <TimeseriesChartYScalesProvider>
      <TimeseriesFormatterProvider>
        <TimeseriesAnnotationsDataProvider>
          {children}
        </TimeseriesAnnotationsDataProvider>
      </TimeseriesFormatterProvider>
    </TimeseriesChartYScalesProvider>
  </TimeseriesChartXScaleProvider>
);

TimeseriesChartProviders['displayName'] = 'TimeseriesChartProviders';
